var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }